import React, { Component } from 'react';
import './App.css';
import functions from "./util/firebase.js"
import Movie from "./components/movie"
import Particles from 'react-particles-js';
import $ from 'jquery';
import axios from 'axios';



class App extends Component {

    constructor(props){
        super(props);

        this.state = {movies:[]};

        functions.getMovieList().then((output) => {
            let titles = [];
            Object.entries(output).map((key) => {
                titles.push(key[0]);
            });
            this.setState({titles:titles});
            this.updateThingy();
        });

        this.handleSubmit = this.handleSubmit.bind(this);


        $(document).on('keyup', (e) => {
            if (e.keyCode === 13) {
                this.handleSubmit();
            }
        });

    }

    handleSubmit(){
        let parameter = $('#search').val().replace(" ","%20");
        let _this = this;
        this.setState({loading:true});
        axios.get('https://sentai-api.herokuapp.com/get-sentiment/'+ parameter)
        .then(function (response) {
            functions.getMovieList().then((output) => {
                let titles = [];
                Object.entries(output).map((key) => {
                    titles.push(key[0]);
                });
                console.log(titles);
                _this.setState({titles:titles, loading:false});
                _this.updateThingy();
            }) 

        })
        .catch(function (error) {
            console.log(error);
        });
        console.log(parameter)


    }

    updateThingy(){
        let movies = [];
        let triplets = [];
        if(this.state.titles){
            this.state.titles.map((key, index) => {
                triplets.push(<Movie title={key} database={functions} key={index}/>);

                if(index % 3 === 2 || index === this.state.titles.length - 1){
                    movies.push(<Triplett triplet={triplets}/>);
                    triplets = []
                }
            });
        }
        this.setState({movies:movies});
    }

    shouldComponentUpdate(nextProps, nextState){
        return true;
    }



    render() {
        console.log("MAAAAIN RENDEREERRERE");

        console.log("");

        console.log("");
        console.log("");
        console.log("");





        return (
            <div className="App">

                <div className="header">
                    <h1 className="title-header"><span className="first-title">Sent</span><span className="second-title">AI</span></h1>
                </div>

                <div className="col-xs-10 col-xs-offset-1 col-md-6 col-md-offset-3">
                    <div className="form-group">
                        <input className="form-control" id="search" name="search" required placeholder="Search for a recent movie" maxLength="50" autoComplete="off"/>
                    </div>
                </div>
                <div className="col-xs-10 col-xs-offset-1 col-md-6 col-md-offset-3">
                    <a id="button-anchor">
                        <div onClick = {this.handleSubmit.bind(this)}id="main-button">
                            <h3 className="unselectable">{!this.state.loading ? "SEARCH" : "LOADING"}</h3>
                        </div>
                    </a>
                </div>

                <div className="container">
                    <div style={{margin:"0 auto"}}>
                        {this.state.movies}
                    </div>
                </div>
                <div className="footer">
                    Written by Cyrus Cowley, Ian Carrasco, Surya Krishnan and Roshan Fernando for SBHacks 2018
                </div>
            </div>
        );
    }

}
function Triplett(props){
    return (
        <div style={{padding:"0"}} className="col-xs-12">
            {props.triplet}
        </div>
    )
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js